import React, { ButtonHTMLAttributes } from 'react';
import { createUseStyles } from 'react-jss';

export interface IconButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {}

const IconButton: React.FC<IconButtonProps> = (props) => {
  const classes = useStyles();
  return <button className={classes.button} {...props} />;
};

const useStyles = createUseStyles({
  button: {
    width: '32px',
    height: '32px',
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default IconButton;
